
import React from "react";
import {
  TabbedForm,
  FormTab
} from "react-admin";
import { generateInputField } from "../factory";
import CreateToolbar from './CreateToolbar'
import {
  useMediaQuery,Grid

} from '@mui/material';

import queryString from 'query-string';


class Form extends React.Component {


  is_defaultValue = false;



  render() {
    // to={`/${resource}/create?keyValue=${id}&keyName=${target}&backTo=${from}&addShortCut=true`}

    const {
      addShortCut: addShortCut_string,
      keyValue: keyValue_string,
      keyName: keyName_string,
      backTo: backTo_string,
      tab: tab_string,
    } = queryString.parse(window.location.hash);



    const { isXSmall, classes, filterValues, resourcesFields, tabs,  id,resourcePermistions, ...props } = this.props;
    var redirect = 'list';
    var keyValue = null;
    var keyName = null;
    var backTo = null;
    var defaultFilterValue = null;
    var tab = '';
    if (addShortCut_string == 'true') {

      this.is_defaultValue = true;
      keyValue = keyValue_string ? keyValue_string : '';
      keyName = keyName_string ? keyName_string : '';
      backTo = backTo_string ? backTo_string : '';
      tab = tab_string ? tab_string : '';

      redirect = keyValue && backTo ? `/${backTo}/${keyValue}/${tab}` : 'show';
      defaultFilterValue = keyValue && backTo ? { [keyName]: keyValue } : {};

    }
   // console.log(resourcesFields);

    return (

      <TabbedForm {...props} defaultValue={this.is_defaultValue ? defaultFilterValue : {}}

        toolbar={<CreateToolbar />}
        redirect={redirect}
      >
        {tabs.map((t, tabIndex) => {
          
          //console.log('t, index', t, index, resourcesFields[index])

          return (
            <TabbedForm.Tab  label={t}  key={`tab-${tabIndex}`}>


             <Grid key={`tab-grid-${tabIndex}`} container item columnSpacing={2}>

              {resourcesFields[tabIndex] && resourcesFields[tabIndex].map((f, index) => {
                  // Create unique key using tabIndex + index + source_name
                  const uniqueKey = `input-${tabIndex}-${index}-${f.source_name || index}`;
                  const inputComponent = generateInputField(f, uniqueKey, id);
                  return (
                    <Grid            
                         key={`fieldg-${tabIndex}-${index}`}     {...props}  item       size={{ xs: f.grid_xs ?? 4, sm: f.grid_sm ?? 4 }}>
                      {inputComponent}
                    </Grid>);


                }


              )}
            </Grid>

          </TabbedForm.Tab>
          )
        })}
      </TabbedForm>


    );
  }
}

const UiTabbedForm= ({ canDelete,resourcesTabs, ...props }) => {

  const isXSmall = useMediaQuery(theme => theme.breakpoints.down('xs'));
  return <Form {...props} />;
};

export default UiTabbedForm;